import { Config } from "../../../api/config";
export var SpareIssueReturnKeys = {
    Paging: "spareIssueReturnPaging",
    InstallbaseDetails: "Installbasedetails",
    JobcardDetails: "jobcardDetailsByIdGet",
    WarehouseList: 'warehouseListGet',
    TechnicianList: 'technicianListGet',
    ServiceAdvisorList: 'serviceAdvisorListGet',
    CustomerAssociationDetails: 'customerDetails',
    PartDetails: 'partDetailsGet',
    LocationDetails: "locationDetailGet",
    GetSerialNumber: 'getSerialNumbers',
    SearchByTypeList: "getSearchByTypeList",
    SpareIssueDataFromJobcard: 'getSpareIssueReturnFromJobcard',
    SpareIssueReturnDetails: 'getSpareIssueReturnDetails',
    Create: 'spareIssueReturnCreate',
    CheckSerialNumber: 'checkSerialNumber',
    Status: 'statusListGet',
    Get: 'GetSPR',
    SpareIssueDetails: 'getSpareIssueDetails',
    SearchDetails: 'SearchDetails'
};
export var APIKeys = [SpareIssueReturnKeys.JobcardDetails, SpareIssueReturnKeys.PartDetails, SpareIssueReturnKeys.CustomerAssociationDetails, SpareIssueReturnKeys.InstallbaseDetails, SpareIssueReturnKeys.SpareIssueReturnDetails, SpareIssueReturnKeys.GetSerialNumber, SpareIssueReturnKeys.Create, SpareIssueReturnKeys.Status, SpareIssueReturnKeys.SearchByTypeList, SpareIssueReturnKeys.LocationDetails];
export var viewTypeOptions = ["My spare issue return", "All spare issue return"];
export var SpareIssueReturnPagingAPIUrl = "".concat(Config.baseURL, "SpareIssueReturn/Paging");
export var getJobCardDetailAPI = "".concat(Config.baseURL, "ProductIssue/GetJobCardDetails");
export var getCustomerByIdAPI = function (id) { return "".concat(Config.baseURL, "Customer/").concat(id, "/Get"); };
export var SpareIssueReturnStatusEnum = /*#__PURE__*/ function (SpareIssueReturnStatusEnum) {
    SpareIssueReturnStatusEnum["Issued"] = "Issued";
    SpareIssueReturnStatusEnum["PartiallyReturned"] = "Partially returned";
    SpareIssueReturnStatusEnum["Returned"] = "Returned";
    SpareIssueReturnStatusEnum["Cancelled"] = "Cancelled";
    SpareIssueReturnStatusEnum["Closed"] = "Closed";
    return SpareIssueReturnStatusEnum;
}({});
